
export function ServicesSection() {
  const services = [
    {
      icon: 'ri-home-4-line',
      title: 'Residential Buying & Selling',
      description: 'Expert guidance through every step of buying or selling your home with personalized service and market expertise.',
      features: ['Market Analysis', 'Negotiation Support', 'Contract Management']
    },
    {
      icon: 'ri-user-heart-line',
      title: 'First-Time Homebuyer Programs',
      description: 'Specialized assistance with MSHDA, VA, and FHA programs to make homeownership accessible and affordable.',
      features: ['MSHDA Programs', 'VA Loans', 'FHA Assistance']
    },
    {
      icon: 'ri-building-line',
      title: 'Investment & Multi-Unit Properties',
      description: 'Strategic investment guidance for building wealth through real estate with comprehensive market insights.',
      features: ['ROI Analysis', 'Property Management', 'Portfolio Building']
    },
    {
      icon: 'ri-ship-line',
      title: 'Waterfront & Luxury Homes',
      description: 'Exclusive access to Metro Detroit\'s finest waterfront properties and luxury home market expertise.',
      features: ['Waterfront Specialists', 'Luxury Market', 'Exclusive Listings']
    },
    {
      icon: 'ri-map-pin-line',
      title: 'Relocation & Dual-State Referrals',
      description: 'Seamless relocation services and trusted referral network for moves within and outside Michigan.',
      features: ['Relocation Support', 'Referral Network', 'Moving Assistance']
    },
    {
      icon: 'ri-line-chart-line',
      title: 'Market Analysis & Consultations',
      description: 'Comprehensive market analysis and property consultations to inform your real estate decisions.',
      features: ['Market Reports', 'Property Valuations', 'Investment Advice']
    }
  ];

  return (
    <section id="services" className="py-20 bg-black">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h3 className="text-4xl font-bold text-white mb-4">
            Comprehensive Real Estate Services
          </h3>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            From first-time buyers to luxury investments, I provide expert guidance across all aspects of Michigan real estate with a commitment to your success.
          </p>
        </div>
        
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div key={index} className="bg-white border-2 border-yellow-500 rounded-lg p-8 hover:border-yellow-400 transition-all duration-300">
              <div className="w-16 h-16 bg-yellow-500 rounded-lg flex items-center justify-center mb-6">
                <i className={`${service.icon} text-2xl text-black`}></i>
              </div>
              <h4 className="text-xl font-bold text-black mb-4">{service.title}</h4>
              <p className="text-gray-600 mb-6 leading-relaxed">{service.description}</p>
              <ul className="space-y-2">
                {service.features.map((feature, idx) => (
                  <li key={idx} className="flex items-center text-sm text-gray-700">
                    <i className="ri-check-line text-yellow-500 mr-2"></i>
                    {feature}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        
        <div className="text-center mt-12">
          <div className="bg-black border-2 border-white text-white rounded-lg p-8 max-w-4xl mx-auto">
            <h4 className="text-2xl font-bold mb-4">Why Choose Shantonya the Realtor®?</h4>
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 text-center">
              <div>
                <i className="ri-award-line text-3xl text-yellow-400 mb-2"></i>
                <div className="font-semibold">Proven Success</div>
                <div className="text-sm text-gray-300">Michigan's most in-demand markets</div>
              </div>
              <div>
                <i className="ri-message-3-line text-3xl text-yellow-400 mb-2"></i>
                <div className="font-semibold">Transparent Communication</div>
                <div className="text-sm text-gray-300">From contract to close</div>
              </div>
              <div>
                <i className="ri-graduation-cap-line text-3xl text-yellow-400 mb-2"></i>
                <div className="font-semibold">Financing Expertise</div>
                <div className="text-sm text-gray-300">Programs and local incentives</div>
              </div>
              <div>
                <i className="ri-heart-line text-3xl text-yellow-400 mb-2"></i>
                <div className="font-semibold">Client Dedication</div>
                <div className="text-sm text-gray-300">Unmatched personal service</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
